import { Route } from 'react-router';
import { ModuleGate } from '../../components/ModuleGate';
import type { BackofficeModule } from '../registry';
import { ImportExportPage } from './ImportExportPage';

/**
 * Einstiegspunkt des Moduls Import und Export im Backoffice (KON-171, Schlüssel `imports`, siehe docs/import-export.md): Daten aus CSV übernehmen und als CSV oder ZIP herausgeben
 * unter /import-export.
 */
export const importsModule: BackofficeModule = {
  key: 'imports',
  path: '/import-export',
  routes: <Route path="import-export" element={<ModuleGate module="imports" permission="imports.read"><ImportExportPage /></ModuleGate>} />,
};
